<template>
  <div class="values-histogram">
    <svg ref="svg" :width="size.width" :height="size.height">
    </svg>
  </div>
</template>

<script>
import d3 from '@/utils/d3importer'
import widgetContent from '@/mixins/widgetContent'

export default {
  name: "ValuesHistogram",
  props: ['data', 'selectionData', 'xAttr', 'nBins'],
  mixins: [widgetContent],
  mounted (){
    // this.drawChart()
  },
  methods:{
    xGetter(d){
      if(!d.scalars) return null
      return +d.scalars.find((d)=>d.name === this.xAttr).value
    },
    drawChart(){
      if(!this.size.height) return
      let self = this
      let margin = {top:20,left:50,right:50,bottom:30}
      let data = this.data || []
      let svg = d3.select(this.$refs.svg)
      let nBin = this.nBins || 20
      let barWidth = 20
      
      let width = this.size.width-margin.left-margin.right
      let height = this.size.height-margin.top-margin.bottom

      let extent = d3.extent(data,(d)=>this.xGetter(d))
      // extent[0]-=0.5
      // extent[1]+=0.5
      let x = d3.scaleLinear().domain(extent).range([0,width])//.nice()
      let y = d3.scaleLinear().range([height,0])

      var histogram = d3.histogram()
        .value(d => this.xGetter(d))
        .domain(x.domain())
        .thresholds(x.ticks(nBin))
      var bins = histogram(data)
      
      let binWidth = bins[1].x1 - bins[1].x0
      bins[0].x0 = bins[0].x1 - binWidth
      bins[bins.length-1].x1 = bins[bins.length-1].x0 + binWidth
      let ticks = bins.map((b)=>b.x0)
      ticks.push(bins[bins.length-1].x1)
      x.domain([bins[0].x0,bins[bins.length-1].x1])
      /*var bandScale = d3.scaleBand()
        .domain(Array.from(Array(bins.length).keys()))
        .range(x.range())
      */
      var maxVal = d3.max(bins, function(d) { return d.length; })
      y.domain([0, maxVal]);
      
      let xPrecision = Math.abs(Math.floor(Math.log10(ticks[1]-ticks[0])))
      let axes = {
        x:d3.axisBottom().scale(x).tickValues(ticks).tickFormat(d3.format(`.${xPrecision}f`)),
        y:d3.axisLeft().scale(y).ticks(Math.min(maxVal, 6)).tickFormat(d3.format("d"))
      }

      let axesUpdate = svg.selectAll('.axis').data(['x','y'])
      let axesEnter = axesUpdate.enter()
        .append('g')
        .attr('class',(d)=>'axis '+d+'-axis')

      axesUpdate.merge(axesEnter).each(function(d){
        let axis = d3.select(this)//.transition()
        axis.call(axes[d]).attr('transform',()=>{
          if(d==='y') return `translate(${margin.left},${margin.top})`
          else return `translate(${margin.left},${self.size.height-margin.bottom})`
        })
        axis.selectAll('.tick').select('line')
          .attr('x1',d==='y'?-margin.left:0)
          .attr('x2',d==='y'?self.size.width:0)
          .attr('y1',d==='x'?-self.size.height:0)
          .attr('y2',d==='x'?margin.bottom:0)
        axis.selectAll('.tick').select('text')
          .attr('dy',d==='x'?'0.7em':'-0.7em')
          //.attr('dx',d==='y'?'-1em': '-1em')
          /*.text((val, index) => {
            if(d==='x' && index < bins.length) {
              debugger
              if(val == 0) return `< ${bins[index].x1.toFixed(2)}`
              if(index == bins.length -1 ) return `> ${bins[index].x0.toFixed(2)}`
              return `${bins[index].x0.toFixed(2)} - ${bins[index].x1.toFixed(2)}`
            }
            return val
          })
          */
        let tickWidth = axis.selectAll('.tick').nodes()[0].getBoundingClientRect().width
        axis.selectAll('.tick').attr('opacity',(dd,i)=>{
          let r = axes[d].scale().range()
          if(tickWidth*1.5>Math.abs((r[1]-r[0])/bins.length)) return i%2===0?1:0
          else return 1
        })
        if(d==='x') axis.selectAll('.domain').attr('d',`M ${-margin.left} 0 h ${self.size.width+margin.right}`)
      })

      let content = svg.selectAll('.content').data([null])
      content = content.merge(content.enter().append('g').attr('class','content'))
      content.attr('transform',`translate(${margin.left},${margin.top})`)

      var u = content.selectAll(".main-rect")
          .data(bins)

      u
        .enter()
        .append("rect")
        .attr("class", "main-rect")
        .on('click', d=> {
          this.$emit('select', this.selected.length>0?this.selected:null)
        })
        .merge(u)
        //.attr("x", (d,i) => /*bandScale(i) + bandScale.bandwidth()*/ x(i)- barWidth/2)
        //.attr("y", self.size.height - margin.bottom - margin.top)
        //.attr("width", barWidth)
        //.attr("height", 0)
        .style("fill", "#E6E9F1")
        .attr("x", 1)
        .attr("transform", d => "translate(" + x(d.x0) + "," + y(d.length) + ")")
        .attr("width", d => x(d.x1) - x(d.x0) -1)
        .attr("height", d => height - y(d.length))
        // .transition()
        // .duration(600)
        //.attr("y", d=>  y(d.length))
        //.attr("height", d => self.size.height - margin.bottom - margin.top - y(d.length))

      u.exit().remove()

      var selData = this.selectionData || []
      var selectionBins = histogram(selData)
      selectionBins[0].x0 = selectionBins[0].x1 - binWidth
      selectionBins[selectionBins.length-1].x1 = selectionBins[selectionBins.length-1].x0 + binWidth
      
      var selectionU = content.selectAll(".selection-rect")
          .data(selectionBins)
      selectionU
        .enter()
        .append("rect")
        .attr("class", "selection-rect")
        .merge(selectionU)
        .attr("x", 1)
        .attr("transform", d => "translate(" + x(d.x0) + "," + y(d.length) + ")")
        .attr("width", d => x(d.x1) - x(d.x0) -1)
        .attr("height", d => height - y(d.length))
        //.attr("x", (d,i) => /*bandScale(i) + bandScale.bandwidth()*/ x(i) - barWidth/2)
        //.attr("y", self.size.height - margin.bottom - margin.top)
        //.attr("width", barWidth)
        //.attr("height", 0)
        .style("fill", "#397DEA")
        // .transition()
        // .delay(600)
        // .duration(600)
        //.attr("y", d=>  y(d.length))
        //.attr("height", d => self.size.height - margin.bottom - margin.top - y(d.length))

      selectionU.exit().remove()
    }

  },
  watch:{
    data(){
      this.drawChart()
    },
    selectionData(){
      this.drawChart()
    },
    xAttr(){
      this.drawChart()
    },
    size(){
      this.drawChart()
    }
  }
}
</script>

<style lang="stylus" scoped>
.values-histogram
  position relative
  >>> svg
    // border solid 1px #f0a
    .axis
      .tick
        line
          stroke-width 0.5px
          stroke rgba(0,0,0,0.3)
      .domain
        stroke-width 0.5px
        stroke rgba(0,0,0,0.3)
</style>